import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { BASE_URL, KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '@/config';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';

import { useUpdateUser } from '../api/update-user';
import { User } from '../types/types';

export function useProfileControllers() {
  const [isMutating, setIsMutating] = useState<boolean>(false);
  const drawer = useDisclosureWithData<Partial<User>>();
  const updateMutation = useUpdateUser();
  const location = useLocation();

  const getUserActionUrl = useCallback(
    (action: string) => {
      const current_location = BASE_URL + location.pathname;
      return `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/auth?response_type=code&client_id=${KEYCLOAK_CLIENT_ID}&redirect_uri=${current_location}&kc_action=${action}`;
    },
    [location]
  );

  const handleChangePassword = useCallback(() => {
    window.location.href = getUserActionUrl('UPDATE_PASSWORD');
  }, [getUserActionUrl]);

  const handleChangeEmail = useCallback(() => {
    window.location.href = getUserActionUrl('UPDATE_EMAIL');
  }, [getUserActionUrl]);

  const handleSubmit = useCallback(
    (data: any) => {
      setIsMutating(true);
      if (data.id) {
        updateMutation
          .mutateAsync({ ...data })
          .then(() => drawer.close())
          .finally(() => setIsMutating(false));
      }
    },
    [updateMutation, setIsMutating, drawer]
  );

  return {
    isMutating,
    drawer,
    updateMutation,
    handleChangePassword,
    handleChangeEmail,
    handleSubmit,
  };
}
